var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: ["progress-bar", ..._vm.variantClassList] }, [
    _vm.$slots.header ||
    _vm.headerTitle1 ||
    _vm.headerTitle2 ||
    _vm.headerWarning
      ? _c(
          "div",
          {
            staticClass: "progress-bar__header",
            attrs: { "data-testid": "progress-bar-header" }
          },
          [
            !_vm.$slots.header
              ? _c("span", { staticClass: "progress-bar__header-title-1" }, [
                  _vm._v(" " + _vm._s(_vm.headerTitle1) + " ")
                ])
              : _vm._e(),
            !_vm.$slots.header
              ? _c("span", { staticClass: "progress-bar__header-title-2" }, [
                  _vm._v(" " + _vm._s(_vm.headerTitle2) + " ")
                ])
              : _vm._e(),
            !_vm.$slots.header
              ? _c("span", { staticClass: "progress-bar__header-warning" }, [
                  _vm._v(" " + _vm._s(_vm.headerWarning) + " ")
                ])
              : _vm._e(),
            _vm._t("header")
          ],
          2
        )
      : _vm._e(),
    _vm.$slots.image
      ? _c(
          "div",
          {
            staticClass: "progress-bar__img",
            attrs: { "data-testid": "progress-bar-image" }
          },
          [_vm._t("image")],
          2
        )
      : _vm._e(),
    _c(
      "ul",
      {
        staticClass: "progress-bar__bar",
        style: _vm.widthStyle,
        attrs: { "data-testid": "progress-bar-steps" }
      },
      _vm._l(_vm.stepArray, function(step) {
        return _c("li", {
          key: step.step,
          class: [
            "progress-bar__bar-section",
            step.complete ? "is-complete" : "is-incomplete"
          ]
        })
      }),
      0
    ),
    _c(
      "div",
      {
        staticClass: "progress-bar__messages",
        attrs: { "data-testid": "progress-bar-messages" }
      },
      [
        !_vm.complete
          ? _c(
              "div",
              { staticClass: "progress-bar__in-progress-message" },
              [
                _vm.$slots.inProgressMessage === undefined
                  ? _c(
                      "span",
                      { staticClass: "progress-bar__in-progress-title" },
                      [_vm._v(" " + _vm._s(_vm.inProgressTitle) + " ")]
                    )
                  : _vm._e(),
                _vm.$slots.inProgressMessage === undefined
                  ? _c(
                      "span",
                      { staticClass: "progress-bar__in-progress-subtitle" },
                      [_vm._v(" " + _vm._s(_vm.inProgressSubtitle) + " ")]
                    )
                  : _vm._e(),
                _vm._t("inProgressMessage")
              ],
              2
            )
          : _vm._e(),
        _vm.complete
          ? _c(
              "span",
              {
                staticClass: "progress-bar__complete-message",
                attrs: { "data-testid": "progress-bar-complete" }
              },
              [
                _vm.$slots.completeMessage === undefined
                  ? _c(
                      "span",
                      { staticClass: "progress-bar__complete-title" },
                      [_vm._v(" " + _vm._s(_vm.completeTitle) + " ")]
                    )
                  : _vm._e(),
                _vm._t("completeMessage")
              ],
              2
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }